import axios from "../../../axios";

const api = {
  getWasteGeneratedInOperationsItems(params, accessToken) {
    const config = {
      params: params.queryParams,
      headers: { "Authorization": `Bearer ${accessToken}` }
    };
    return axios.get(`/supplier-questionnaires/${params.questionnaireId}/waste-generated-in-operations/items`,
      config).then(({ data }) => data);
  },

  addWasteGeneratedInOperationsItems({ questionnaireId, data }, accessToken) {
    const headers = { headers: { "Authorization": `Bearer ${accessToken}` } };
    return axios.post(`/supplier-questionnaires/${questionnaireId}/waste-generated-in-operations/items`, data, headers)
      .then(({ data }) => data);
  },

  updateWasteGeneratedInOperationsItem({ questionnaireId, recordId, data }, accessToken) {
    const headers = { headers: { "Authorization": `Bearer ${accessToken}` } };
    return axios.put(`/supplier-questionnaires/${questionnaireId}/waste-generated-in-operations/items/${recordId}`, data, headers)
      .then(({ data }) => data);
  },

  deleteWasteGeneratedInOperationsItem({ questionnaireId, recordId }, accessToken) {
    const headers = { headers: { "Authorization": `Bearer ${accessToken}` } };
    return axios.delete(`/supplier-questionnaires/${questionnaireId}/waste-generated-in-operations/items/${recordId}`, headers)
      .then(({ data }) => data);
  },

  importWasteGeneratedInOperationsItems({ questionnaireId, data }, accessToken) {
    const headers = {
      headers: { "Authorization": `Bearer ${accessToken}` }
    };
    return axios.post(`/supplier-questionnaires/${questionnaireId}/waste-generated-in-operations/items/import`, data, headers).then(({ data }) => data);
  },

  getWasteGeneratedInOperationsPreviewData({ previewId, params }, accessToken) {
    const config = {
      params,
      headers: { "Authorization": `Bearer ${accessToken}` }
    };
    return axios.get(`/supplier-questionnaires/preview/${previewId}/waste-generated-in-operations/items`, config).then(({ data }) => data);
  },
};

export default api;